<template>
  <div class="content custas content_custas p-1">
    <h4 class="custas_title">
      <b>Custas</b>
    </h4>

    <div v-if="vigencias.length">
      <div class="custas_subtitle p-2">
        <div class="row">
          <div class="col pt-1">
            Vigência: {{ vigenciaSelecionada }}
          </div>

          <div class="col" />

          <div class="col">
            <b-form-select v-model="vigenciaSelecionada"
                           size="sm"
                           :options="vigencias"
                           @change="atualizaListagemCustas" />
          </div>
        </div>
      </div>

      <div class="pl-3 pr-3">
        <b-row align-h="between"
               class="mb-4">
          <div class="ml-3 mt-3 col-9 p-0">
            <div class="custom-control custom-radio custom-control-inline row">
              <div class="mx-3">
                <input id="registro_civil"
                       v-model="tipoCusta"
                       v-validate="'required'"
                       class="custom-control-input"
                       name="livro_registro"
                       required
                       type="radio"
                       value="REGISTRO_CIVIL"
                       @change="changeTipo()">

                <label class="custom-control-label"
                       for="registro_civil">
                  Registro Civil
                </label>
              </div>

              <div class="ml-5">
                <input id="firmas"
                       v-model="tipoCusta"
                       v-validate="'required'"
                       class="custom-control-input"
                       name="livro_registro"
                       required
                       type="radio"
                       value="FIRMA"
                       @change="changeTipo()">

                <label class="custom-control-label"
                       for="firmas">
                  Atos Notariais
                </label>
              </div>
            </div>
          </div>

          <div v-if="vigenciaSelecionada">
            <div class="mt-3 mr-3">
              <b-button variant="secondary"
                        size="sm"
                        :disabled="registroOficial === 1"
                        @click="showModal()">
                <svg class="button_edit_label_icon icon--xxs"
                     role="presentation">
                  <use :xlink:href="'#' + iconAdd.id" />
                </svg>
                Adicionar Item
              </b-button>
            </div>
          </div>
        </b-row>

        <b-tabs class="ResumoCustas-border"
                align="left"
                active-nav-item-class="ResumoCustas--tab-active">
          <b-tab :active="registroOficial === 1"
                 @click="changeTab('padrao')">
            <template v-slot:title>
              Padrão
            </template>
          </b-tab>

          <b-tab :active="registroOficial === 0"
                 @click="changeTab('personalizada')">
            <template v-slot:title>
              Personalizada
            </template>
          </b-tab>
        </b-tabs>

        <Table :fields="tipoCusta === 'REGISTRO_CIVIL' ? fieldsRegistroCivil : fieldsFirma"
               :data="custas"
               :is-busy="isBusy"
               field-search="descricao"
               @showModal="showModal"
               @onUpdateAtivo="updateAtivo" />
      </div>

      <Pagination :per-page="perPage"
                  :page="page"
                  :last-page="lastPage"
                  @onPreviousPage="previousPage"
                  @onNextPage="nextPage" />

      <form autocomplete="off"
            class="no-padding">
        <CustaModal :show="showModalForm"
                    :tipo-custa="tipoCusta"
                    :vigencia="vigenciaSelecionada"
                    :custa="custaToModal"
                    @atualizarLista="atualizaListagemCustas"
                    @onCalcel="() => {showModalForm = false, custaToModal = null}" />
      </form>
    </div>

    <div v-else>
      <label class="pt-3 pl-3">
        Nenhuma custa encontrada.
      </label>
    </div>
  </div>
</template>

<script>
  /* constants */
  import { getAtos, getAtosByCodigoCusta } from '@/constants/atosCustas'

  /* components */
  import Table from '@/components/SofiaRei/Table'
  import Pagination from '@/components/SofiaRei/Pagination'
  import CustaModal from '@/views/SofiaRei/CustaModal.vue'

  /* assets */
  import add from '@/assets/icons/add.svg?sprite'

  /* services */
  import CustasService from '@/services/Registros/CustasService'
  import PapelSegurancaLoteService from '@/services/PapelSeguranca/PapelSegurancaLoteService'
  import CartorioService from "@/services/CartorioService"
  
  /* outros */
  import moment from 'moment'
  import { VMoney } from 'v-money'
  import { mapGetters } from 'vuex'

  // Entitites
  import Custa from '@/entities/Custas/Custa.js'

  const DESTINATARIO_1 = {
    prefixo: 'AO',
    sufixo: 'OFICIAL'
  }

  const FormBase = {
    codigo: null,
    vigencia: null,
    tipo: null,
    ato: null,
    tipo_ato: null,
    ativo: 1,
    livro_caixa: false,
    recolhimento: false,
    registro_civil: false,
    itens: [],
    registroCivil: {
      destinatario_1: null,
      iss: null,
      destinatario_2: null
    },
    firma: {
      tabeliao: null,
      estado: null,
      ipesp: null,
      municipio: null,
      ministerio_publico: null,
      registro_civil: null,
      tribunal_justica: null,
      santa_casa: null,
    },
    editar: false,
    tipo_impresso_seguranca_personalizado: null
  }

  export default {
    name: "Custas",
    components: {
      Pagination,
      Table,
      CustaModal
    },
    directives: {
      money: VMoney
    },
    data () {
      return {
        // Utilizamos nos campos de valores
        money: {
          decimal: ',',
          thousands: '.',
          prefix: 'R$ ',
          suffix: '',
          precision: 2,
          masked: false
        },

        // Icone
        iconAdd: add,

        // Vigência
        vigencias: [],
        vigenciaSelecionada: null,

        // Paginação
        page: 1,
        perPage: 10,
        lastPage: 1,

        // Controle modal
        modalReadOnly: false,
        form: null,
        custaToModal: null,
        showModalForm: false,

        // Custas
        tipoCusta: 'REGISTRO_CIVIL',
        registroOficial: 1,
        custas: [],
        nomeDestinatario2: '',

        // Componente Table
        isBusy: false, // ativar ou desativar o loader
        fieldsRegistroCivil: [
          {
            key: 'id',
            label: 'Ativo'
          },
          {
            key: 'codigo',
            label: 'Código'
          },
          {
            key: 'ato',
            label: 'Ato'
          },
          {
            key: 'destinatario_1',
            label: 'AO OFICIAL'
          },
          {
            key: 'iss',
            label: 'ISS'
          },
          {
            key: 'destinatario_2',
            label: '' // Atualizamos dinamicamente
          },
          {
            key: 'total',
            label: 'Total'
          },
          {
            key: 'acoes',
            label: ''
          }
        ],
        fieldsFirma: [
          {
            key: 'id',
            label: 'Ativo'
          },
          {
            key: 'ato',
            label: 'Ato'
          },
          {
            key: 'tabeliao.valorReal',
            label: 'Tabelião'
          },
          {
            key: 'estado.valorReal',
            label: 'Estado'
          },
          {
            key: 'ipesp.valorReal',
            label: 'Sec. da Fazenda'
          },
          {
            key: 'municipio.valorReal',
            label: 'Município'
          },
          {
            key: 'ministerio_publico.valorReal',
            label: 'Min. Público'
          },
          {
            key: 'registro_civil.valorReal',
            label: 'Reg. Civil'
          },
          {
            key: 'tribunal_justica.valorReal',
            label: 'Trib. Just.'
          },
          {
            key: 'santa_casa.valorReal',
            label: 'Sta. Casa'
          },
          {
            key: 'total',
            label: 'Total'
          },
          {
            key: 'acoes',
            label: ''
          }
        ],

        // Código selo digital -> Custa Personalizada
        tipoAtoSelecionado: null,
        codigoAto: null,
        tiposAtos: [],
        tiposAtosComMesmoCodigo: [],

        tipos_de_papeis: [],
        tipos_de_selos: [],
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId',
        cartorioObj: 'auth/getCartorioObj'
      })
    },
    async beforeMount () {
      try {
        loader({ text: 'Obtendo dados...', active: true })
        // Deixa a table com carregando as informações
        this.isBusy = true

        // this.form = this.getFormBase()

        // INÍCIO: este código atualiza dinamicamente o cabeçalho 'ISS' com a alíquota de ISSQN.
        const {data: {aliquota_issqn}} = await CartorioService.getCartorioRei(this.$store.state.auth.cartorio_id)

        this.fieldsRegistroCivil = this.fieldsRegistroCivil.map(field => {
          return {
            key: field.key,
            label: field.label === 'ISS' ? `ISS (${aliquota_issqn}%)` : field.label
          }
        })
        // FIM: atualização do cabeçalho 'ISS' com a alíquota de ISSQN concluída.

        await this.getVigencias()
        await this.getCustas()

        // Mapeamentos dos atos para o v-select
        this.tiposAtos = getAtos().map(ato => {
          return {
            label: `${ato.codigo}: ${ato.descricao}`,
            value: ato.codigo,
            codigo: ato.codigosCusta[0]
          }
        })
      } catch (e) {
        console.error(e)
      } finally {
        // Tiramos o carregamento do table
        this.isBusy = false
        loader({ text: '', active: false })
      }
    },
    async created () {
      const listTiposResponse = await PapelSegurancaLoteService.listTipos()
      this.tipos_de_papeis = listTiposResponse.tipos_de_papeis
      this.tipos_de_selos = listTiposResponse.tipos_de_selos
    },
    methods: {
      setCodigoAto (ev) {
        this.tipoAtoSelecionado = ev.value
        this.codigoAto = ev.codigo
      },
      async getCustas () {
        // this.form = this.getFormBase()

        const { data, lastPage } = await CustasService.getCustas({
          perPage: this.perPage,
          page: this.page,
          tipo: this.tipoCusta,
          registro_oficial: this.registroOficial,
          vigencia: moment(this.vigenciaSelecionada, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          cartorio_id: !this.registroOficial ? this.$store.state.auth.cartorio_id : null,
          os: 0
        })

        for (const custa of data) {
          // Inicial o total é 0
          custa.total = 0

          for (const itemCusta of custa.itens) {
            if (this.tipoCusta === 'FIRMA') {
              custa[itemCusta.destino] = {
                ...itemCusta,
                valorReal: this.centsToReal(itemCusta.valor)
              }
            }

            if (this.tipoCusta === 'REGISTRO_CIVIL') {
              itemCusta.valorReal = this.centsToReal(itemCusta.valor)

              const itemUpperCase = itemCusta.destino.toUpperCase()

              if (this.validaDestinatario1(itemUpperCase)) {
                custa['destinatario_1'] = itemCusta.valorReal
              } else if (itemUpperCase === 'ISS') {
                custa['iss'] = itemCusta.valorReal
              } else if (itemUpperCase === 'A SEC. FAZ.') {
                this.nomeDestinatario2 = itemUpperCase
                custa['destinatario_2'] = itemCusta.valorReal
              }
            }

            custa.total += itemCusta.valor
            itemCusta.registroOficial = this.registroOficial

            if (custa.ESTADO) {
              custa.estado = custa.ESTADO
            }
            if (custa.IPESP) {
              custa.ipesp = custa.IPESP
            }
            if (custa.ISS) {
              custa.municipio = custa.ISS
            }
            if (custa['MINISTERIO PUBLICO']) {
              custa.ministerio_publico = custa['MINISTERIO PUBLICO']
            }
            if (custa['REGISTRO CIVIL']) {
              custa.registro_civil = custa['REGISTRO CIVIL']
            }
            if (custa['SANTA CASA']) {
              custa.santa_casa = custa['SANTA CASA']
            }
            if (custa['TABELIAO']) {
              custa.tabeliao = custa['TABELIAO']
            }
            if (custa['TRIBUNAL JUSTICA']) {
              custa.tribunal_justica = custa['TRIBUNAL JUSTICA']
            }
          }

          custa.total = this.centsToReal(custa.total)

          // Verificamos se a custa é da vingência atual, se não for desabilitamos o switch de ativo
          custa.vingenciaAtual = (moment(custa.vigencia).format('DD/MM/YYYY') === this.vigencias[0])
        }

        if (this.tipoCusta === 'REGISTRO_CIVIL') {
          // Caso a tab for personalizada retiramos a coluna código
          const campoCodigo = this.fieldsRegistroCivil.find(campo => campo.key === 'codigo')

          if (!this.registroOficial && campoCodigo) {
            this.fieldsRegistroCivil.splice(1, 1)
          }

          if (this.registroOficial && !campoCodigo) {
            this.fieldsRegistroCivil.splice(1, 0, {
              key: 'codigo',
              label: 'Código'
            })
          }

          // Atualizamos o nome da coluna do destinatário 2
          this.fieldsRegistroCivil[this.registroOficial ? 5 : 4] = {
            key: 'destinatario_2',
            label: this.nomeDestinatario2
          }
        }

        this.custas = data
        this.lastPage = lastPage
      },
      async previousPage () {
        this.page -= 1

        await this.atualizaListagemCustas()
      },
      async nextPage () {
        this.page += 1

        await this.atualizaListagemCustas()
      },
      async atualizaListagemCustas () {
        try {
          this.isBusy = true

          //await this.getVigencias()
          await this.getCustas()
        } catch (e) {
          console.error(e)

          this.vigencias = []
          this.vigenciaSelecionada = null
          this.tipoAtoSelecionado = null
        } finally {
          this.isBusy = false
        }
      },
      centsToReal (cents) {
        return (cents / 100).toLocaleString('pt-BR', {
          style: 'currency',
          currency: 'BRL'
        })
      },
      realToCents (real) {
        if (!real) return

        return real.replace(/\D/g, '')
      },
      validaDestinatario1 (item) {
        return item.includes(DESTINATARIO_1.prefixo, 0) &&
          item.includes(DESTINATARIO_1.sufixo, 1)
      },
      showModal (custa) {
        if (custa) {
          this.custaToModal = custa.data
          this.showModalForm = true          
        } else {
          this.custaToModal = null
          this.showModalForm = true      

        }
      },
      async updateAtivo (custa) {
        if (custa.vigencia_antiga && !custa.ativo) {
          const vigenciaAntiga = moment(custa.vigencia_antiga).format('DD/MM/YYYY')
          objSwal.question.title = `Essa custa pertence à uma vigência anterior (${vigenciaAntiga})`
          objSwal.question.text = 'Verifique os detalhes antes de ativar. Tem certeza que deseja continuar?'
          const result = await Swal.fire(objSwal.question)
          if (!result.value) return custa.ativo = 0
        }

        if (custa.custa_info_iss_id && custa.registro_oficial) return

        try {
          await CustasService.atualizaAtivo(custa.custa_id)
        } catch (error) {
          const message = getErrors(error)

          await displayMessage('error', 'Erro!', message.message)
        } finally {
          await this.atualizaListagemCustas()
        }
      },
      async changeTipo () {
        this.page = 1
        await this.getVigencias()
        await this.atualizaListagemCustas()
      },
      async changeTab (tipo) {
        this.registroOficial = tipo === 'padrao' ? 1 : 0

        await this.atualizaListagemCustas()
      },
      totalView () {
        let total = 0

        if (this.tipoCusta === 'REGISTRO_CIVIL' && this.form.registroCivil) {
          Object.keys(this.form.registroCivil).forEach(item => {
            total += parseFloat(this.realToCents(this.form.registroCivil[item]))
          })
        }

        if (this.tipoCusta === 'FIRMA' && this.form.firma) {
          Object.keys(this.form.firma).forEach(item => {
            total += parseFloat(this.realToCents(this.form.firma[item]))
          })
        }

        return this.centsToReal(total)
      },

      async getVigencias () {
        const vigencias = await CustasService.getVigenciasByTipo(this.tipoCusta)

        if (!vigencias.length) return

        this.vigencias = vigencias.map(vigencia => moment(vigencia).format('DD/MM/YYYY'))
        this.vigenciaSelecionada = this.vigencias[0]
      },
      getImpressoDeSegurancaLabel (value) {
        if (!value) return 'Não consumir'

        const impresso = [...this.tipos_de_papeis, ...this.tipos_de_selos].find(impresso => impresso.value === value)
        return impresso && impresso.label || 'Não encontrado'
      },
      getFormBase () {
        // Deep copy
        return {...FormBase}
      }
    }
  }
</script>

<style lang="scss">
  @import '@/scss/_utilities/_exports';

  .button_edit_label_icon {
    fill: #fff;
  }

  .button_delete_label_icon {
    fill: #fff;
  }

  .content_custas {
    max-width: 85.375rem;
  }

  .custas {
    &_modal .modal-dialog {
      min-width: 50%;
    }

    &_title {
      background-color: $sinoreg-blue;
      color: $color-white;
      font-size: pxToRem(24);
      font-weight: 500;
      padding: pxToRem(10) pxToRem(20);
    }

    &_subtitle {
      background-color: $color-gray-light;
      font-weight: 500;
    }

    &_label {
      font-size: pxToRem(16);
    }

    &_total {
      background-color: $color-gray-light;
      font-weight: 500;
    }
  }

  .ResumoCustas-border ul.nav {
    border-bottom: 0 solid #01BFA5 !important;
  }
  .ResumoCustas-border ul.nav > li > a,
  .ResumoCustas-border ul.nav > li > a:hover {
    border-bottom: 0 solid #01BFA5 !important;
    border-right: 1px solid lightgray !important;
    border-left: 1px solid lightgray !important;
    border-top: 1px solid lightgray !important;
    color: black;
  }

  .ResumoCustas--tab-active {
    background-color: #01BFA5 !important;
    border: 1px solid #01BFA5 !important;
    color: white !important;
  }
</style>
